"use strict";

$('.js-phone-mask').mask('+7 (999) 999 99-99');

$('.js-toggle-modal').magnificPopup({
  type: 'inline',

  fixedContentPos: false,
  fixedBgPos: true,

  overflowY: 'auto',

  closeBtnInside: true,
  preloader: false,
  
  midClick: true,
  removalDelay: 300,
  mainClass: 'mfp-with-zoom'
});

lightGallery(document.querySelector(".gallery-container"), {
  speed: 500,
  plugins: [lgZoom],
  showZoomInOutIcons: false,
  actualSize: false
});

$('.js-modal-sentence').magnificPopup({
  type: 'inline',

  fixedContentPos: false,
  fixedBgPos: true,

  overflowY: 'auto',

  closeBtnInside: true,
  preloader: false,
  
  midClick: true,
  removalDelay: 300,
  mainClass: 'mfp-with-zoom',

  callbacks: {
    beforeOpen: function() {
      const staticValueTextarea = $('.js-sentence-get').val(),
            modalTextarea = $('.js-sentence-set');
      
      if(staticValueTextarea !== '' && modalTextarea.val() === '') {
        modalTextarea.val(staticValueTextarea)
      }
    },
  },
});

$('.js-modal-login').magnificPopup({
  type: 'inline',

  fixedContentPos: false,
  fixedBgPos: true,

  overflowY: 'auto',

  closeBtnInside: true,
  preloader: false,
  
  midClick: true,
  removalDelay: 300,
  mainClass: 'mfp-with-zoom',
});